/* ========================================================================
   zy-product.js — Phase 3 + Phase 5 bugfix v2 (safe drawer open, see
   zy-product-card.js for details on why the first fix was reverted)
   ======================================================================== */
(function () {
  var root = document.querySelector('[data-zy-product-section]');
  if (!root) return;

  var productDataEl = root.querySelector('[data-zy-product-json]');
  var productData = null;
  try { productData = productDataEl ? JSON.parse(productDataEl.textContent) : null; } catch (e) {}

  var slides = Array.prototype.slice.call(root.querySelectorAll('[data-zy-slide]'));
  var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-zy-thumb]'));
  var counter = root.querySelector('[data-zy-gallery-counter]');
  var activeIndex = 0;

  function showSlide(index) {
    if (!slides.length) return;
    activeIndex = (index + slides.length) % slides.length;
    slides.forEach(function (s, i) {
      var active = i === activeIndex;
      s.hidden = !active;
      s.classList.toggle('zy-gallery__slide--active', active);
    });
    thumbs.forEach(function (t, i) {
      var active = i === activeIndex;
      t.classList.toggle('zy-gallery__thumb--active', active);
      t.setAttribute('aria-selected', active ? 'true' : 'false');
    });
    if (counter) counter.textContent = (activeIndex + 1) + ' / ' + slides.length;
  }
  function showSlideByMediaId(mediaId) {
    var idx = -1;
    for (var i = 0; i < slides.length; i++) {
      if (slides[i].getAttribute('data-media-id') === String(mediaId)) { idx = i; break; }
    }
    if (idx > -1) showSlide(idx);
  }

  root.querySelector('[data-zy-gallery-prev]') && root.querySelector('[data-zy-gallery-prev]').addEventListener('click', function () { showSlide(activeIndex - 1); });
  root.querySelector('[data-zy-gallery-next]') && root.querySelector('[data-zy-gallery-next]').addEventListener('click', function () { showSlide(activeIndex + 1); });
  thumbs.forEach(function (t, i) { t.addEventListener('click', function () { showSlide(i); }); });

  root.querySelector('[data-zy-gallery-stage]') && root.querySelector('[data-zy-gallery-stage]').addEventListener('keydown', function (e) {
    if (e.key === 'ArrowLeft') { showSlide(activeIndex - 1); }
    if (e.key === 'ArrowRight') { showSlide(activeIndex + 1); }
  });

  var selectedOptions = {};
  root.querySelectorAll('[data-zy-variant-option][aria-checked="true"]').forEach(function (btn) {
    selectedOptions[btn.getAttribute('data-option-position')] = btn.getAttribute('data-value');
  });

  function findMatchingVariant() {
    if (!productData) return null;
    return productData.variants.find(function (v) {
      var opts = [v.option1, v.option2, v.option3];
      return Object.keys(selectedOptions).every(function (pos) {
        return opts[parseInt(pos, 10) - 1] === selectedOptions[pos];
      });
    }) || null;
  }

  function formatMoney(cents) {
    return (window.Shopify && Shopify.formatMoney)
      ? Shopify.formatMoney(cents, (window.theme && window.theme.moneyFormat) || '${{amount}}')
      : '$' + (cents / 100).toFixed(2);
  }

  function updateForVariant(variant) {
    if (!variant) return;

    var addBtn = root.querySelector('[data-zy-add-to-cart]');
    var addLabel = root.querySelector('[data-zy-add-label]');
    var buyNow = root.querySelector('[data-zy-buy-now]');
    var formVariantInput = root.querySelector('[data-zy-form-variant-id]');
    var skuWrap = root.querySelector('[data-zy-sku]');
    var skuValue = root.querySelector('[data-zy-sku-value]');
    var priceCurrent = root.querySelector('[data-zy-price-current]');
    var priceCompare = root.querySelector('[data-zy-price-compare]');
    var priceOff = root.querySelector('[data-zy-price-off]');
    var stickyPrice = root.querySelector('.zy-sticky-bar__price');
    var stickyAdd = root.querySelector('[data-zy-sticky-add]');

    if (addBtn) {
      addBtn.setAttribute('data-variant-id', variant.id);
      addBtn.disabled = !variant.available;
    }
    if (addLabel) addLabel.textContent = variant.available ? 'Add to cart' : 'Sold out';
    if (buyNow) {
      buyNow.setAttribute('data-variant-id', variant.id);
      /* Bug fix: Buy Now must reflect variant availability the same way
         Add to Cart does. It's an <a>, not a real form control, so
         `disabled` has no effect — use aria-disabled + a class instead,
         and guard the click handler below (see the click listener). */
      if (variant.available) {
        buyNow.classList.remove('is-disabled');
        buyNow.removeAttribute('aria-disabled');
      } else {
        buyNow.classList.add('is-disabled');
        buyNow.setAttribute('aria-disabled', 'true');
      }
    }
    if (formVariantInput) formVariantInput.value = variant.id;
    if (stickyAdd) stickyAdd.setAttribute('data-variant-id', variant.id);

    if (priceCurrent) priceCurrent.textContent = formatMoney(variant.price);
    if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      if (priceCompare) { priceCompare.textContent = formatMoney(variant.compare_at_price); priceCompare.hidden = false; }
      if (priceOff) {
        var off = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
        priceOff.textContent = '−' + off + '%'; priceOff.hidden = false;
      }
    } else {
      if (priceCompare) priceCompare.hidden = true;
      if (priceOff) priceOff.hidden = true;
    }

    if (skuWrap && skuValue) {
      if (variant.sku) { skuValue.textContent = variant.sku; skuWrap.hidden = false; }
      else { skuWrap.hidden = true; }
    }

    if (variant.featured_media && variant.featured_media.id) {
      showSlideByMediaId(variant.featured_media.id);
    }

    var url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url);

    if (window.zyAnnounce) {
      window.zyAnnounce(variant.available ? 'Selected ' + (variant.public_title || variant.title) + ', ' + formatMoney(variant.price) + '.' : 'Selected variant is sold out.');
    }
  }

  root.querySelectorAll('[data-zy-variant-option]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var pos = btn.getAttribute('data-option-position');
      var value = btn.getAttribute('data-value');
      selectedOptions[pos] = value;

      var group = btn.closest('.zy-variant-group');
      group.querySelectorAll('[data-zy-variant-option]').forEach(function (b) {
        b.classList.toggle('zy-variant-swatch--selected', b === btn);
        b.setAttribute('aria-checked', b === btn ? 'true' : 'false');
      });
      var label = group.querySelector('[data-zy-selected-value-label]');
      if (label) label.textContent = value;

      var match = findMatchingVariant();
      if (match) updateForVariant(match);
    });
  });

  var qtyInput = root.querySelector('[data-zy-qty-input]');
  root.querySelector('[data-zy-qty-decrease]') && root.querySelector('[data-zy-qty-decrease]').addEventListener('click', function () {
    if (!qtyInput) return;
    qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
  });
  root.querySelector('[data-zy-qty-increase]') && root.querySelector('[data-zy-qty-increase]').addEventListener('click', function () {
    if (!qtyInput) return;
    qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1;
  });

  function apiRoot() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }

  var addBtn = root.querySelector('[data-zy-add-to-cart]');
  if (addBtn) {
    addBtn.addEventListener('click', function () {
      if (addBtn.disabled) return;
      var variantId = addBtn.getAttribute('data-variant-id');
      var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
      addBtn.dataset.loading = 'true';
      fetch(apiRoot() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: qty }] })
      })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function (item) {
          if (window.zyAnnounce) window.zyAnnounce((item && item.product_title ? item.product_title : 'Item') + ' added to cart.');
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          if (window.zyOpenCartDrawer) {
            window.zyOpenCartDrawer();
          } else {
            var drawer = document.querySelector('cart-drawer-component');
            if (drawer && typeof drawer.open === 'function') { try { drawer.open(); } catch (e) {} }
          }
        })
        .catch(function () {
          if (window.zyAnnounce) window.zyAnnounce('Sorry, that item could not be added to your cart.');
        })
        .finally(function () { addBtn.dataset.loading = 'false'; });
    });
  }

  var stickyAddBtn = root.querySelector('[data-zy-sticky-add]');
  if (stickyAddBtn) {
    stickyAddBtn.addEventListener('click', function () {
      addBtn && addBtn.click();
    });
  }

  var buyNowBtn = root.querySelector('[data-zy-buy-now]');
  if (buyNowBtn) {
    buyNowBtn.addEventListener('click', function (e) {
      e.preventDefault();
      /* Bug fix: block navigation when the current variant is sold out. */
      if (buyNowBtn.classList.contains('is-disabled') || buyNowBtn.getAttribute('aria-disabled') === 'true') { return; }
      var variantId = buyNowBtn.getAttribute('data-variant-id');
      var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
      window.location.href = apiRoot() + 'cart/' + variantId + ':' + qty;
    });
  }

  var stickyBar = root.querySelector('[data-zy-sticky-bar]');
  var buyBox = root.querySelector('.zy-buy-box');
  if (stickyBar && buyBox && 'IntersectionObserver' in window) {
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        stickyBar.hidden = false;
        stickyBar.dataset.visible = entry.isIntersecting ? 'false' : 'true';
      });
    }, { threshold: 0 });
    obs.observe(buyBox);
  }

  var relatedRoot = root.querySelector('[data-zy-related]');
  var relatedGrid = root.querySelector('[data-zy-related-grid]');
  if (relatedRoot && relatedGrid) {
    var url = relatedRoot.getAttribute('data-url');
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var cards = doc.querySelectorAll('.zy-card');
        if (!cards.length) { relatedRoot.hidden = true; return; }
        cards.forEach(function (card) { relatedGrid.appendChild(card); });
      })
      .catch(function () { relatedRoot.hidden = true; });
  }
})();
